import { IRestaurant } from '@/shared/model/restaurant.model';

export interface IRestaurantWorkingTimes {
  id?: number;
  day?: number | null;
  deliverFromHour?: Date | null;
  deliverToHour?: Date | null;
  pickupFromHour?: Date | null;
  pickupToHour?: Date | null;
  restaurant?: IRestaurant | null;
  deliverFromHourString?: string | null;
  deliverToHourString?: string | null;
  pickupFromHourString?: string | null;
  pickupToHourString?: string | null;
}

export class RestaurantWorkingTimes implements IRestaurantWorkingTimes {
  constructor(
    public id?: number,
    public day?: number | null,
    public deliverFromHour?: Date | null,
    public deliverToHour?: Date | null,
    public pickupFromHour?: Date | null,
    public pickupToHour?: Date | null,
    public restaurant?: IRestaurant | null
  ) {}

  public get deliverFromHourString(): string {
    return this.timeGetterFunc('deliverFromHour');
  }
  public set deliverFromHourString(newDeliverFromHourString: string) {
    this.deliverFromHour = this.setHoursFunc(newDeliverFromHourString);
  }
  public get deliverToHourString(): string {
    return this.timeGetterFunc('deliverToHour');
  }
  public set deliverToHourString(newDeliverToHourString: string) {
    this.deliverToHour = this.setHoursFunc(newDeliverToHourString);
  }
  public get pickupFromHourString(): string {
    return this.timeGetterFunc('pickupFromHour');
  }
  public set pickupFromHourString(newPickupFromHourString: string) {
    this.pickupFromHour = this.setHoursFunc(newPickupFromHourString);
  }
  public get pickupToHourString(): string {
    return this.timeGetterFunc('pickupToHour');
  }
  public set pickupToHourString(newPickupToHourString: string) {
    this.pickupToHour = this.setHoursFunc(newPickupToHourString);
  }

  private timeGetterFunc(field: string): string {
    return this[field] ? this.checkTime(this[field].getHours()) + ':' + this.checkTime(this[field].getMinutes()) : '';
  }

  private setHoursFunc(newHour: string): Date {
    const newDate = newHour ? new Date() : null;
    const newHourArray = newHour?.split(':');
    newDate && newDate.setHours(parseInt(newHourArray[0], 10));
    newDate && newDate.setMinutes(parseInt(newHourArray[1], 10));
    return newDate;
  }

  private checkTime(time: number): string {
    return time >= 10 ? time.toString() : '0' + time;
  }
}
